"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WisdomMindset() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return;
}